import React, { useCallback } from 'react'
import { Route, Switch } from 'react-router'
import { useHistory } from 'react-router-dom'
import { Tabs } from 'antd'
import { Panel } from '../../../core/components/styled'
import { useLastPathnameSegment } from '../../../common/hooks/router'
import ScrapingTagsManagementPage from './scraping-tags-management-page'
import ScrapingTagGroupsPage from './scraping-tag-groups-page'

const ScrapingTagsPage = () => {
  const history = useHistory()
  const currentTab = useLastPathnameSegment()

  const handleChangeTab = useCallback(
    tabKey => history.push(`/scraping/tags/${tabKey}`),
    [history],
  )

  return (
    <>
      <Panel margin="small no no no">
        <Tabs type="card" activeKey={currentTab} onChange={handleChangeTab}>
          <Tabs.TabPane tab="Tag management" key="management" />
          <Tabs.TabPane tab="Tag groups" key="groups" />
        </Tabs>
      </Panel>

      <Switch>
        <Route
          path="/scraping/tags/management"
          component={ScrapingTagsManagementPage}
        />
        <Route path="/scraping/tags/groups" component={ScrapingTagGroupsPage} />
      </Switch>
    </>
  )
}
export default ScrapingTagsPage
